module.exports = __webpack_public_path__ + "img/homeszzt.835ac996.svg";